import { useTranslation } from "react-i18next";
import { useCallback } from "react";

export type SupportedLanguage = "en" | "fr";

export function useLanguage() {
  const { i18n } = useTranslation();

  const currentLanguage = (i18n.language?.startsWith("fr") ? "fr" : "en") as SupportedLanguage;

  const changeLanguage = useCallback(
    (lang: SupportedLanguage) => {
      i18n.changeLanguage(lang);
      document.documentElement.lang = lang;
    },
    [i18n],
  );

  return { currentLanguage, changeLanguage };
}
